import * as Yup from 'yup';
import i18next from 'i18next';

export const appointmentFormSchema = Yup.object().shape({
  participantsCount: Yup.number()
    .when('bbbMaxAttendees', ([bbbMaxAttendees], schema) =>
      schema.max(bbbMaxAttendees, i18next.t('meetings.tooManyParticipantsWithNumber', { number: bbbMaxAttendees })),
    )
    .when('service', ([service], participantsSchema) => {
      return service.value === ''
        ? participantsSchema.optional()
        : participantsSchema
            .required(i18next.t('validation.tooFewParticipants'))
            .positive(i18next.t('validation.tooFewParticipants'));
    }),

  service: Yup.object().when('categories', ([categories], schema) => {
    const categoryStrings = categories as string[];
    if (
      !categories ||
      (categoryStrings.length === 1 && categoryStrings[0] === 'onSite') ||
      (categoryStrings.includes('onSite') && !categoryStrings.includes('virtual'))
    ) {
      return schema.shape({
        value: Yup.string().optional(),
      });
    }

    return schema.shape({
      value: Yup.string()
        .required(i18next.t('validation.noServiceSelected'))
        .min(2, i18next.t('validation.noServiceSelected')),
    });
  }),

  duration: Yup.number().min(1, i18next.t('validation.durationTooShort')),

  title: Yup.string()
    .required(i18next.t('validation.required.appointment.title'))
    .min(3, i18next.t('validation.textTooShort')),

  categories: Yup.array().min(1, i18next.t('validation.noLessonType')),

  startDate: Yup.date()
    .required(i18next.t('validation.required.date'))
    .max(Yup.ref('endDate'), i18next.t('validation.time.startDateAfterEnd')),
  startTime: Yup.date()
    .required(i18next.t('validation.required.time'))
    .max(Yup.ref('endTime'), i18next.t('validation.time.startTimeAfterEnd')),
  endDate: Yup.date()
    .required(i18next.t('validation.required.date'))
    .min(Yup.ref('startDate'), i18next.t('validation.time.endDateBeforeStart')),
  endTime: Yup.date()
    .required(i18next.t('validation.required.time'))
    .min(Yup.ref('startTime'), i18next.t('validation.time.endTimeBeforeEnd'))
    .not([Yup.ref('startTime')], i18next.t('validation.time.endTimeBeforeEnd')),
});
